<template>
    <div class="mgt-28 d-flex flex-row-reverse">
        <button class="mdc-button mdc-button--outlined mdc-button--dense btn-white2 t-color-secondaryBtnText tip-botton-border " @click="showTip()">
            <i class="material-icons mdc-button__icon"><img src="@/assets/tip.svg" alt=""></i>
            {{$t('1244')}}
        </button>
        <!-- {{tip}} -->
   
    </div>
    
</template>

<script>
/**
 * 문항별 팁 공통 컴포넌트(question tip common component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
export default {
    props: ['tip'],
     mounted() {
        this.setMaterialUi()
    },
    methods: {
        showTip() {            
            let tipText = this.tip.text
            let tipfile = ''
            if (this.tip.file) {
                if (this.tip.file.contentType === 'image/jpeg' || this.tip.file.contentType === 'image/png') {
                    tipfile = `<div class="contents-mask mgb-16 independent-img-video-bd-radius"><img src="${this.tip.file.resourceUri}" class="w-full"></div>`
                }else if (this.tip.file.contentType === 'video/mp4') {
                    tipfile = `<div class="contents-mask mgb-16 independent-img-video-bd-radius"><video src="${this.tip.file.resourceUri}" controls id="hintVideo" class="w-full"></video></div>`
                }
            }

            
            let alertParams = {
                title: this.$t('1403'), // Refer to the hint!
                content: `${tipfile}${tipText}`,
                accept: this.$t('1404')
            }
            this.$alert(alertParams).then(() => {
                if (this.tip.file.contentType === 'video/mp4') {
                    document.getElementById('hintVideo').pause()
                }
            })
        },
         setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },        
    }
}
</script>